import { SCREEN_S } from '../styles/variables';

export const isMobile = () => window.innerWidth < SCREEN_S;
